import styled, {css} from "styled-components";
import {styledByTheme} from "../../../../../themes/architecture/styled-by-theme";

const FilterItemTitleDefaultBox = styled.span<{isChecked: boolean}>`
  margin-left: 2em;
  font-size: 1.5rem;
  ${({theme}) => theme.font.presets.medium};
  color: ${props => props.theme.colors.text};
  ${props => props.isChecked ? css`color: ${props => props.theme.colors.brandPrimary};` : ''}
`;

const FilterItemTitleMrGreenBox = styled(FilterItemTitleDefaultBox)`
  color: ${props => props.isChecked ? props.theme.colors.textContrast : props.theme.colors.text};
`;

const FilterItemTitleSIBox = styled(FilterItemTitleDefaultBox)`
  color: ${props => props.isChecked ? props.theme.colors.textContrast : props.theme.colors.text};
  font-size: 12px;
  font-weight: 400;
`;

export const FilterItemTitleBox = styledByTheme(FilterItemTitleDefaultBox)
  .forSI(FilterItemTitleSIBox)
  .forSICis(FilterItemTitleSIBox)
  .forMrGreen(FilterItemTitleMrGreenBox)
  .forMrGreenCis(FilterItemTitleMrGreenBox).apply();
